<div class="modal-container">
  <div class="modal-header">
    <h3 class="modal-title">
      {{ room.roomName }}
    </h3>
    <rx-button buttonClass="subtle-circle" (click)="activeModal.dismiss()">
      <i class="rx-close"></i>
    </rx-button>
  </div>
  <div class="modal-body">
    <rx-applications-room-more-details [room]="room"></rx-applications-room-more-details>
  </div>
  <div class="modal-footer"></div>
</div>
